exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[data-v-825cde4a]{margin-left:auto;margin-right:auto;max-width:62.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-825cde4a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Beads.vue
// module id = 37
// module chunks = 1